import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=77cdbb52&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=77cdbb52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cdbb52",
  null
  
)

export default component.exports